import "../assets/index-edee3304.css";
import a from "./NcActions.mjs";
import { n as i } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const s = {
  name: "NcAppNavigationCaption",
  components: {
    NcActions: a
  },
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      required: !0
    },
    /**
     * Any [NcActions](#/Components/NcActions?id=ncactions-1) prop
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {}
  },
  computed: {
    // Check if the actions slot is populated
    hasActions() {
      return !!this.$slots.actions;
    }
  }
};
var o = function() {
  var t = this, n = t._self._c;
  return n("li", { staticClass: "app-navigation-caption" }, [n("h2", { staticClass: "app-navigation-caption__name" }, [t._v(" " + t._s(t.name) + " ")]), t.hasActions ? n("div", { staticClass: "app-navigation-caption__actions" }, [n("NcActions", t._g(t._b({ scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t._t("actionsTriggerIcon")];
  }, proxy: !0 }], null, !0) }, "NcActions", t.$attrs, !1), t.$listeners), [t._t("actions")], 2)], 1) : t._e()]);
}, e = [], c = /* @__PURE__ */ i(
  s,
  o,
  e,
  !1,
  null,
  "f01eb538",
  null,
  null
);
const u = c.exports;
export {
  u as default
};
